import React from "react";
import { ConfigsProvider } from './components/ConfigsContext';
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./App.css";
import NavBar from "./NavBar";
import Home from "./Home";
import Footer from "./Footer";
import SocialIcons from "./SocialIcons";
import { BrowserRouter as Router, Routes, Route} from "react-router-dom";
import DetailsPage from "./DetailsPage";
import ScrollToTop from "./ScrollToTop";
import TermsAndConditions from "./TermsAndConditions";
import ServicesDetails from "./ServicesDetails";
import CeoSpeaks from "./CeoSpeaks";
import SimTarrif from "./SimTarrif";
import RechargePolicy from "./RechargePolicy";
import Offers from "./Offers";
import Discounts from "./Discounts"

const App = () => {
  return (
   <ConfigsProvider>
      <Router>
        <ScrollToTop />
        <div className="app-grid">
          <header>
            <NavBar />
          </header>
          <main>
            <SocialIcons />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="sim-tariff" element={<SimTarrif />} />
              <Route path="promotions/details" element={<DetailsPage />} />
              <Route path="services/details" element={<ServicesDetails />} />
              <Route
                path="/terms-and-conditions"
                element={<TermsAndConditions />}
              />
              <Route path="/ceo-speaks" element={<CeoSpeaks />} />
              <Route path="/online-recharge-policy" element={<RechargePolicy />} />
              <Route path="/offers" element={<Offers />} />
              <Route path="/more-discounts" element={<Discounts />} />

			  <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <footer>
            <Footer />
          </footer>
        </div>
      </Router>
	 </ConfigsProvider>
  );
};
export default App;
